// Studio-scoped URLs need an id, and `manage_studio_id` is null for an owner
// who is not attached to a studio yet. Interpolating that straight into a
// template produced `/studios/undefined/my_business/overview`, which matches
// the route pattern and then 404s inside CanCan.
//
// Falling back to the studio hub keeps the click useful instead of dead.
const FALLBACK = "/my_studio";

export const studioSectionPath = (studioId, section = "overview") =>
  (studioId ? `/studios/${studioId}/my_business/${section}` : FALLBACK);

export default studioSectionPath;
